import * as React from "react";
import { ChildProps, graphql } from "react-apollo";
import gql from "graphql-tag";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import {
  columnConfigFactory,
  GqlWithdrawalRequest,
} from "./withdrawalRequestsColumns";
import { RouteComponentProps, withRouter } from "react-router";

const PAGE_LIMIT = 20;

type GqlData = {
  withdrawal_requests: Array<GqlWithdrawalRequest>;
};

type Props = ChildProps<
  {
    name: string;
    createdAtFrom: string;
    createdAtTo: string;
    status: string;
  } & RouteComponentProps &
    PaginationProps,
  GqlData
>;

class AllWithdrawalRequestsContainer extends React.Component<Props> {
  onAction() {
    this.props.data.refetch();
  }

  render() {
    return (
      <BOGraphQLLoader data={this.props.data}>
        <ConfigurableTable
          name={this.props.name}
          pagination={this.props.pagination}
          history={this.props.history}
          columnConfigs={columnConfigFactory(this.onAction.bind(this))}
          defaultColumns={[
            "Created At",
            "User",
            "Payable Amount",
            "Status",
            "Batch",
            "Actions",
          ]}
          rows={this.props.data.withdrawal_requests || []}
          rowToLink={(withdrawal: GqlWithdrawalRequest) =>
            `/snapscan/wallet_withdrawals/${withdrawal.reference}/summary`
          }
        />
      </BOGraphQLLoader>
    );
  }
}

const withdrawalListGql = gql`
  query WalletWithdrawalRequests(
    $offset: Int
    $limit: Int
    $createdAtFrom: String
    $createdAtTo: String
    $status: WithdrawalRequestStatus
  ) {
    withdrawal_requests(
      offset: $offset
      limit: $limit
      created_at_from: $createdAtFrom
      created_at_to: $createdAtTo
      status: $status
    ) {
      created_at
      reference
      status
      user {
        external_reference
        email
        snapmin_url
      }
      payable_amount
      withdrawal_batch {
        id
        status
      }
    }
  }
`;

const withWithdrawalsGqlData = graphql<GqlData, Props>(withdrawalListGql, {
  options: (props) => {
    const {
      createdAtFrom,
      createdAtTo,
      status,
      pagination: { offset, limit },
    } = props;

    return {
      fetchPolicy: "network-only",
      variables: {
        createdAtFrom,
        createdAtTo,
        status,
        offset,
        limit,
      },
    };
  },
});

export default withPagination(
  withRouter(withWithdrawalsGqlData(AllWithdrawalRequestsContainer)),
  PAGE_LIMIT
);
